import {Capacitor} from '@capacitor/core'
import {LocalNotifications} from '@capacitor/local-notifications'
import {Camera} from '@capacitor/camera'

export async function requestNativePermissions(): Promise<void> {
    if (!Capacitor.isNativePlatform()) return

    try {
        const stream = await navigator.mediaDevices.getUserMedia({audio: true})
        stream.getTracks().forEach(t => t.stop())
    } catch { /* denied — app continues */ }

    try {
        await LocalNotifications.requestPermissions()
    } catch { /* denied — app continues */ }

    try {
        await Camera.requestPermissions({permissions: ['photos', 'camera']})
    } catch { /* denied — app continues */ }
}
